import { useMemo } from 'react';

import { useMovementPageData } from '#src/app/pages/movement/pageContext';

type Data = {
	movementId: string;
	slug: string;
	petitionCount: string;
	createdAt: string;
	updatedAt: string;
	ownerId: string;
	urls: {
		movementAdmin: string;
		addPetitions: string;
		userAdmin: string;
	};
};

type Result = ModelHookResult<Data>;

export function useMovementStaffDrawer(): Result {
	const {
		data: {
			movement: { id, slug, petitionCount, createdAtLocalized, updatedAtLocalized, owner },
		},
	} = useMovementPageData();

	const urls = useMemo(
		() => ({
			movementAdmin: `/admin/m/${id}`,
			addPetitions: `/admin/movement_petitions/new?movement_id=${id}`,
			userAdmin: `/admin/u/${owner.id}`,
		}),
		[id, owner.id],
	);

	return {
		data: {
			movementId: id,
			slug,
			petitionCount: String(petitionCount),
			createdAt: createdAtLocalized,
			updatedAt: updatedAtLocalized,
			ownerId: owner.id,
			urls,
		},
	};
}
